import Modal from "../../../components/Modal/Modal";
import { Form, Formik } from "formik";
import FilledButton from "../../../components/FilledButton/FilledButton";
import * as Yup from "yup";
import { useStore } from "../../../store/useStore";
import { DocumentUpload } from "iconsax-react";
import { Colors } from "../../../utils/constants/style";
import OutlinedButton from "../../../components/OutlinedButton/OutlinedButton";

const initialValues = {
  inputFile: null
};

const BatchInsertMacrosModal: React.FC<{}> = () => {
  const importFile = useStore((state) => state.import.importFile);
  const importType = useStore((state) => state.import.importType);
  const isUploadingFile = useStore(
    (state) => state.import.isUploadingFile
  );

  return (
    <Modal
      title="Criar em lote"
      icon={<DocumentUpload width={30} height={30} color={Colors.white} />}
      className="w-[500px]"
      childrenClassName="px-5 overflow-y-auto"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          inputFile: Yup.mixed()
            .nullable()
            .required("Campo obrigatório"),
        })}
        onSubmit={async (values) => {
          if (!values.inputFile) {
            return;
          }

          // Convert file to base64
          const toBase64 = (file: File) =>
            new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => {
                // Remove the "data:*/*;base64," prefix if your backend expects only the base64 string
                const base64String = (reader.result as string).split(',')[1];
                resolve(base64String);
              };
              reader.onerror = error => reject(error);
            });

          const base64 = await toBase64(values.inputFile);

          importFile({
            file: base64
          });
        }}
      >
        {({ setFieldValue }) => (
          <Form>
            <div className="flex flex-col items-center gap-8 pt-5">
              <div className="gap-3">
                <div
                  className={`justify-center text-center w-fit rounded-[8px] text-sm font-bold px-2 py-1 mb-5 bg-light-orange text-orange`}
                >
                  Para criar macros em lote, baixe o arquivo modelo, preencha com os dados seguindo as instruções abaixo e importe o arquivo preenchido.
                </div>
                <div className="flex justify-center">
                  <a
                    className="underline underline-offset-4 text-red text-sm"
                    href="https://jornada-sat-public.s3.us-east-1.amazonaws.com/docs/template-insercao-macros.csv"
                  >
                    Baixar arquivo modelo
                  </a>
                </div>
                <div className="border border-gray_02 rounded-[8px] p-4 my-5 text-sm w-full">
                  <center><strong>Modelo dos dados:</strong></center><br />
                  <p><strong>Origem: </strong>JORNADASAT, ONIXSAT, SASCAR, OMNILINK ou RODOPAG</p>
                  <p><strong>Data: </strong>O formato deve ser dd/MM/yyyy</p>
                  <p><strong>Hora: </strong>O formato deve ser hh:mm:ss</p><br />
                  <center><p>Todos os dados das colunas são obrigatórios</p></center>
                </div>
                <div className="flex justify-center border border-gray_02 rounded-[8px] p-4">
                  <input
                    type="file"
                    name="inputFile"
                    accept=".csv"
                    className="block w-full text-sm text-gray_2 rounded-lg cursor-pointer
                    file:text-red file:rounded-[8px] file:font-light file:transition file:duration-200 
                    file:ease-in-out file:py-2 file:px-3 file:border file:border-red file:bg-white 
                    file:hover:bg-red file:hover:text-white file:cursor-pointer file:mr-5"
                    onChange={e => {
                      if (e.currentTarget.files && e.currentTarget.files[0]) {
                        setFieldValue("inputFile", e.currentTarget.files[0]);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="flex justify-end mb-6">
                <FilledButton
                  loading={isUploadingFile}
                  className="w-full h-[40px] min-w-[200px]"
                  type="submit"
                >
                  Importar macros
                </FilledButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default BatchInsertMacrosModal;
